/**
 * Class description
 *
 * Created: 2019-08-01
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WinterHoardGameAssets} from "../WinterHoardGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

export class WinterHoardReelBackground extends BaseView {

    private readonly _reelBackgroundPos: number[] = [21, 201, 381, 561, 741];
    private _background: PIXI.Sprite;

    private _mainBackground: PIXI.spine.Spine;
    private _mainAnimation: string;
    private _fsAnimation: string;

    private _mainSky: PIXI.Sprite;
    private _fsSky: PIXI.Sprite;

    private _foreground: PIXI.Sprite;
    private _fgLayer: ScalableLayer;

    constructor() {
        super();
        StageManager.getLayer(WinterHoardLayerConfig.REEL_BACKGROUND.name).addChild(this);
        this._fgLayer = StageManager.getLayer(WinterHoardLayerConfig.REEL_FRAME.name);
    }

    protected initAnimations(): void {
        //const sizeRef:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(WinterHoardGameAssets.REEL_BACKGROUND)[0]);
        this._mainSky = new PIXI.Sprite(GameResources.getTextures("mainSky")[0]);
        this._mainSky.scale.set(2, 2);
        this._mainSky.anchor.set(0.5, 0.5);
        this._mainSky.position.set(460, 0);
        this.addChild(this._mainSky);

        this._fsSky = new PIXI.Sprite(GameResources.getTextures("fsSky")[0]);
        this._fsSky.scale.set(2, 2);
        this._fsSky.anchor.set(0.5, 0.5);
        this._fsSky.position.set(460, 0);
        this.addChild(this._fsSky);

        this._mainBackground = new PIXI.spine.Spine(GameResources.getSpineAsset("bgSpine"));
        this._mainBackground.position.set(480, 360);
        const animation: any = this._mainBackground.skeleton.data.animations;

        this._mainAnimation = animation[0].name;
        this._fsAnimation = animation[1].name;

        this.addChild(this._mainBackground);
        this._mainBackground.state.setAnimation(0, this._mainAnimation, true);

        this._background = new PIXI.Sprite();
        this._background.anchor.set(0.5, 0.5);
        this._background.position.set(0, 0);

        this._reelBackgroundPos.forEach((rid:number, id:number) => {
            const dsprite:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
            dsprite.width = id===0?196:176;
            dsprite.height = 600;
            dsprite.tint = 0x000000;
            dsprite.alpha = 0.55;

            dsprite.x = 180 * id -470 -(id===0?20:0);
            dsprite.y = -300;

            this._background.addChild(dsprite);
        });

        this._background.x = 34;
        this._foreground = new PIXI.Sprite(GameResources.getTextures(WinterHoardGameAssets.REEL_FG)[0]);

        this.addChild(this._background);
        this._fgLayer.addChild(this._foreground);

        //const layout = new PIXI.Sprite(GameResources.getTextures(WinterHoardGameAssets.LAYOUT)[0]);
        //layout.alpha = 0.5;
        //layout.position.set(372, 302);
        //layout.anchor.set(0.5, 0.5);
        //layout.scale.set(0.9, 0.9);
        //this._fgLayer.addChild(layout);

        this.switchBg();
    }

    public switchBg(mode: string = "main"): void {

        if (mode === "main") {
            this._mainBackground.state.setAnimation(0, this._mainAnimation, true);
            this._fsSky.visible = false;
            this._mainSky.visible = true;
        } else {
            this._mainBackground.state.setAnimation(0, this._fsAnimation, true);
            this._mainSky.visible = false;
            this._fsSky.visible = true;
        }

    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.LANDSCAPE) {
            this._foreground.scale.set(0.9, 0.9);
            this._background.scale.set(0.9, 0.825);
            this._background.position.set(463, 247);
            this.scale.set(0.8, 1.1);
            this.x = 22.5; //GameConfig.instance.REEL_AREA_POS_X * 1.15;
            this.y = 60; //GameConfig.instance.REEL_AREA_POS_Y * 1.15 + 120;

            this._foreground.x = 0;
            this._foreground.y = 25;
        } else {
            this.scale.set(0.75, 0.855);
            this.x = -10;
            this.y = 70;
            this._background.scale.set(1.05, 1.15);
            this._background.position.set(527, 346);
            this._foreground.scale.set(0.995, 0.995);
            this._foreground.x = -52.5;
            this._foreground.y = 30;
        }
    }


}